<template>
  <vs-row>
    <!-- 그래프 1 -->
    <vs-col class="w-full pb-4">
      <monthly-chart-card :title="graph1.title" :year="graph1.year" :data1="graph1.data1" :data2="graph1.data2" :sum1="graph1.sum1" :sum2="graph1.sum2" @change="yearChangeForGraph1" />
    </vs-col>

    <div class="w-full grid grid-cols-1 lg:grid-cols-2 gap-x-2 gap-y-4 mb-4">
      <!-- 그래프 2-->
      <vs-col>
        <monthly-comparison-card :title="graph2.title" :year="graph2.year" :month="graph2.month" :unit="graph2.unit" :heads="graph2.heads" :list="graph2.list" :getCol="getColForGraph2" @change="dateChangeForGraph2">
          <template v-if="projectId" slot="tools" :set="(lv = getLevel)">
            <vs-button v-for="(button, idx) in getButtons" :key="idx" class="py-3 px-0 lg:px-8" type="border"
                       :color="button.dataType === graph2.dataType ? 'primary' : 'secondary'"
                       @click="dataTypeChangeForGraph2(button.dataType)">{{ button.label }}</vs-button>
          </template>
        </monthly-comparison-card>
      </vs-col>

      <!-- 그래프 3 -->
      <vs-col>
        <daily-comparison-card dateType="yyyy-mm" :title="graph3.title" :unit="graph3.unit" :year="graph3.year" :month="graph3.month" :list="graph3.list" @change="dateChangeForGraph3">
          <template v-if="projectId" slot="tools" :set="(lv = getLevel)">
            <vs-button v-for="(button, idx) in getButtons" :key="idx" class="py-3 px-0 lg:px-8" type="border"
                       :color="button.dataType === graph3.dataType ? 'primary' : 'secondary'"
                       @click="dataTypeChangeForGraph3(button.dataType)">{{ button.label }}</vs-button>
          </template>
        </daily-comparison-card>
      </vs-col>
    </div>

    <!-- 그래프 4-->
    <vs-col class="w-full pb-4">
      <monthly-comparison-card :title="graph4.title" :year="graph4.year" :month="graph4.month" :unit="graph4.unit" :heads="graph4.heads" :list="graph4.list" :getCol="getColForGraph4" @change="dateChangeForGraph4">
        <template slot="tools">
          <div class="w-full">
            <vs-select class="w-full lg:w-48" autocomplete v-model="graph4.dataType1" @change="dataType1ChangeForGraph4">
              <vs-select-item value="부서" text="부서별" />
              <vs-select-item value="사업장" text="사업장별" />
            </vs-select>
          </div>
          <vs-button class="py-3 px-0 lg:px-8" type="border"
                     :color="graph4.dataType2 === '구분' ? 'primary' : 'secondary'"
                     @click="dataType2ChangeForGraph4('구분')">{{ $t('구분') }}</vs-button>
          <vs-button class="py-3 px-0 lg:px-8" type="border"
                     :color="graph4.dataType2 === '구분_직종' ? 'primary' : 'secondary'"
                     @click="dataType2ChangeForGraph4('구분_직종')">{{ $t('구분+직종') }}</vs-button>
        </template>
      </monthly-comparison-card>
    </vs-col>
  </vs-row>
</template>

<script>
/* eslint-disable brace-style */
import MonthlyChartCard from "@/views/graph-detail/components/MonthlyChartCard";
import MonthlyChartCard2 from "@/views/graph-detail/components/MonthlyChartCard2";
import MonthlyComparisonCard from "@/views/graph-detail/components/MonthlyComparisonCard";
import DailyComparisonCard from "@/views/graph-detail/components/DailyComparisonCard";
import tabItems from "@/views/boards/tab/tab-items";

export default {
  name: "GraphDetail02",
  components: {
    DailyComparisonCard,
    MonthlyComparisonCard,
    MonthlyChartCard2,
    MonthlyChartCard,
  },
  props: {
    comGroupList: Object,
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    graphId() {
      return Number(this.$route.params.graphId);
    },
    isApproval() {
      return tabItems[299].isApproval;
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const project of projects) {
          if (`${project.id}` === `${this.projectId}` && project.company.length > 0) {
            const path = project.company[0].pivot.company_path;
            return path.split("/").length - 1;  // LEVEL
          }
        }
      }
      return 4;
    },
    getButtons() {
      switch (this.getLevel) {
      case 1:
        return [
          { label: '관련 부서', dataType: '부서' },
          { label: '사업장/시설물', dataType: '사업장' },
          { label: '구분', dataType: '구분' },
          { label: '직종', dataType: '직종' },
        ]
      case 2:
        return [
          { label: '관련 부서', dataType: '부서' },
          { label: '구분', dataType: '구분' },
          { label: '직종', dataType: '직종' },
        ]
      case 3:
        return [
          { label: '구분', dataType: '구분' },
          { label: '직종', dataType: '직종' },
        ]
      case 4:
        return [
          { label: '구분', dataType: '구분' },
          { label: '직종', dataType: '직종' },
        ]
      }
    }
  },
  data() {
    return {
      boardId: 433,
      summaryKey: ["종사자_직종", "count"],
      graph1: {
        title: "종사자 등록 현황",
        year: new Date().getFullYear(),
        data1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 선택한 년도
        data2: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 선택한 년도의 이전 년도
        sum1: "0",
        sum2: "0",
      },
      graph2: {
        title: "월별 종사자 인원 현황",
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        unit: "",
        heads: [{ name: "No." }, { name: "부서(업체명)" }, { name: "명" }, { name: "전월대비 증감" }],
        list: [],
        summaryKey1: "",
        dataType: "부서",
      },
      graph3: {
        title: "월별 종사자 인원 현황",
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        unit: "",
        beginDate: new Date().format("yyyy-MM-dd"),
        endDate: new Date().format("yyyy-MM-dd"),
        list: [],
        dataType: "부서",
      },
      graph4: {
        title: "상세 내부종사자 현황",
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        unit: "",
        heads: [{ name: "No." }, { name: "부서명" }, { name: "구분" }, { name: "명" }, { name: "전월대비 증감" }],
        list: [],
        summaryKey1: "",
        dataType1: "부서",
        dataType2: "구분",
      },
      cache: {},
    };
  },
  async mounted() {
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
    await this.loadDetailData();

    this.graph2.dataType = this.getButtons[0].dataType;
    this.graph3.dataType = this.getButtons[0].dataType;
    this.dataTypeChangeForGraph2(this.getButtons[0].dataType, this.getButtons[0].label);

    await this.loadGraph1();
    await this.loadGraph2();
    await this.loadGraph3();
    await this.loadGraph4();
  },

  methods: {
    // API에서 상세 정보를 불러온다
    async loadDetailData(currentYear) {
      if (!currentYear) {
        currentYear = new Date().getFullYear();
      }

      // 캐시에 저장되어 있으면, 캐시에서 불러온다
      if (this.cache[currentYear]) {
        return this.cache[currentYear];
      }
      // 캐시에 저장되어 있지 않으면, API에서 불러온다
      else {
        const params = {
          projectId: this.projectId,
          currentYear,
        };
        const data = await this.$store.dispatch("summary/LOAD_DONUT_EMPLOYEE_DETAIL", params);
        this.cache[currentYear] = data;
        return data;
      }
    },

    // 그래프 1
    async loadGraph1() {
      const yyyy = this.graph1.year;
      const data = await this.loadDetailData(yyyy);
      const graph1Data = data.monthly;
      const currentYear = graph1Data[yyyy];
      const prevYear = graph1Data[yyyy - 1];

      // 첫번째 배열은 총 합이므로, 데이터에서 제외한다
      currentYear.shift();
      prevYear.shift();

      this.graph1.data1 = currentYear;
      this.graph1.data2 = prevYear;
      this.graph1.sum1 = `${currentYear[prevYear.length - 1]}`;
      this.graph1.sum2 = `${prevYear[currentYear.length - 1]}`;
      console.log({prevYear, currentYear});
    },
    yearChangeForGraph1(year) {
      this.graph1.year = year;
      this.loadGraph1();
    },

    // 그래프 2
    async loadGraph2() {
      const yyyy = this.graph2.year;
      const data = await this.loadDetailData(yyyy)
      let graph2Data = [];
      switch (this.graph2.dataType) {
      case "부서":
        graph2Data = data.company;
        break;
      case "사업장":
        graph2Data = data.field;
        break;
      case "직종":
        graph2Data = data.employment_type;
        break;
      case "구분":
        graph2Data = data.job_category;
        break;
      default:
        return;
      }
      console.log('loadGraph2', {data, graph2Data});

      const currentYear = yyyy;
      const currentMonth = this.graph2.month;
      const prevYear = currentMonth === 1 ? currentYear - 1 : currentYear;
      const prevMonth = currentMonth === 1 ? 12 : currentMonth - 1;

      const currentData = graph2Data[currentYear][currentMonth];
      const prevData = graph2Data[prevYear][prevMonth];

      const list = [];
      let no = 1;

      for (const row of currentData) {
        const prevRow = prevData.find((item) => item.label === row.label);
        const gap = prevRow ? row.count - prevRow.count : row.count;
        list.push({
          no,
          name: row.label,
          value: row.count,
          gap,
        });
        no += 1;
      }

      // prevData 중에서 list에 포함되지 않은 데이터를 찾아서 추가한다
      for (const row of prevData) {
        const currentRow = currentData.find((item) => item.label === row.label);
        if (!currentRow) {
          list.push({
            no,
            name: row.label,
            value: 0,
            gap: -row.count,
          });
          no += 1;
        }
      }

      this.graph2.list = list;
    },

    convertListData(list) {
      // 데이터 변형하기,
      // 매달 마지막에 작성 글을 기준으로 변경하기,
      const temp = {};
      for (const data of list) {
        const date = new Date(data.created_at).format("yyyy-MM-01");
        if (data.post_content) {
          temp[date] = JSON.parse(data.post_content);
        }
      }
      return temp;
    },


    getColForGraph2(index, value) {
      if (index === 0) return value.no;
      if (index === 1) return value.name;
      if (index === 2) return value.value;
      if (index === 3) {
        let updown = "default";
        if (value.gap > 0) updown = "up";
        else if (value.gap < 0) updown = "down";
        return { type: updown, value: value.gap };
      }
      return "";
    },

    yearChangeForGraph2(year) {
      this.graph2.year = year;
      this.loadGraph2();
    },
    dataTypeChangeForGraph2(dataType) {
      this.graph2.dataType = dataType;

      if (dataType === "부서") this.graph2.heads = [{ name: "No." }, { name: "부서(업체)명" }, { name: "명" }, { name: "전월대비 증감" }];
      else if (dataType === "사업장") this.graph2.heads = [{ name: "No." }, { name: "사업장명" }, { name: "명" }, { name: "전월대비 증감" }];
      else if (dataType === "구분") this.graph2.heads = [{ name: "No." }, { name: "구분" }, { name: "명" }, { name: "전월대비 증감" }];
      else if (dataType === "직종") this.graph2.heads = [{ name: "No." }, { name: "직종" }, { name: "명" }, { name: "전월대비 증감" }];

      this.loadGraph2();
    },
    dateChangeForGraph2(year, month) {
      this.graph2.year = year;
      this.graph2.month = month;
      this.loadGraph2();
    },

    // 그래프 3
    async loadGraph3() {
      const yyyy = this.graph3.year;

      const data = await this.loadDetailData(yyyy)
      let graph2Data = [];
      switch (this.graph3.dataType) {
      case "부서":
        graph2Data = data.company;
        break;
      case "사업장":
        graph2Data = data.field;
        break;
      case "직종":
        graph2Data = data.employment_type;
        break;
      case "구분":
        graph2Data = data.job_category;
        break;
      default:
        return;
      }

      const currentYear = yyyy;
      const currentMonth = this.graph3.month;
      const currentData = graph2Data[currentYear][currentMonth];

      const list = [];

      for (const row of currentData) {
        list.push({
          label: row.label,
          value: row.count,
        });
      }

      this.graph3.list = list;
    },
    dateRangeChangeForGraph3(beginDate, endDate) {
      this.graph3.beginDate = beginDate;
      this.graph3.endDate = endDate;
      this.loadGraph3();
    },
    dateChangeForGraph3(year, month) {
      this.graph3.year = year;
      this.graph3.month = month;
      this.loadGraph3();
    },
    dataTypeChangeForGraph3(dataType) {
      this.graph3.dataType = dataType;
      this.loadGraph3();
    },

    // 그래프 4
    async loadGraph4() {
      const yyyy = this.graph4.year;

      const data = await this.loadDetailData(yyyy);

      let graph4Data = [];
      const list = [];
      if (this.graph4.dataType1 === "부서") {
        if (this.graph4.dataType2 === "구분") {
          graph4Data = data.company_and_employment_type;
        } else if (this.graph4.dataType2 === "구분_직종") {
          graph4Data = data.company_and_employment_type_and_job_category;
        }
      } else if (this.graph4.dataType1 === "사업장") {
        if (this.graph4.dataType2 === "구분") {
          graph4Data = data.field_and_employment_type;
        }
        else if (this.graph4.dataType2 === "구분_직종") {
          graph4Data = data.field_and_employment_type_and_job_category;
        }
      }

      const currentYear = yyyy;
      const currentMonth = this.graph4.month;
      const prevYear = currentMonth === 1 ? currentYear - 1 : currentYear;
      const prevMonth = currentMonth === 1 ? 12 : currentMonth - 1;

      const currentData = graph4Data[currentYear][currentMonth];
      const prevData = graph4Data[prevYear][prevMonth];

      let no = 1;

      //console.log(this.graph4.dataType2, {graph4Data, currentData})

      for (const row of currentData) {
        const prevRow = prevData.find((item) => item.key === row.key);
        const gap = prevRow ? row.count - prevRow.count : row.count;
        list.push({
          no,
          부서명: row.label_1,
          구분: row.label_2,
          직종: row.label_3,
          value: row.count,
          gap,
        });
        no += 1;
      }

      // prevData 중에서 list에 포함되지 않은 데이터를 찾아서 추가한다
      for (const row of prevData) {
        const currentRow = currentData.find((item) => item.key === row.key);
        if (!currentRow) {
          list.push({
            no,
            부서명: row.label_1,
            구분: row.label_2,
            직종: row.label_3,
            value: 0,
            gap: -row.count,
          });
          no += 1;
        }
      }

      this.graph4.list = list;
    },
    getColForGraph4(index, value) {
      if (this.graph4.dataType2 === "구분_직종") {
        if (index === 0) return value.no;
        if (index === 1) return value["부서명"];
        if (index === 2) return value["구분"];
        if (index === 3) return value["직종"];
        if (index === 4) return value.value;
        if (index === 5) {
          let updown = "default";
          if (value.gap > 0) updown = "up";
          else if (value.gap < 0) updown = "down";
          return { type: updown, value: value.gap };
        }
      } else {
        if (index === 0) return value.no;
        if (index === 1) return value["부서명"];
        if (index === 2) return value["구분"];
        if (index === 3) return value.value;
        if (index === 4) {
          let updown = "default";
          if (value.gap > 0) updown = "up";
          else if (value.gap < 0) updown = "down";
          return { type: updown, value: value.gap };
        }
      }
      return "";
    },

    dateChangeForGraph4(year, month) {
      this.graph4.year = year;
      this.graph4.month = month;
      this.loadGraph4();
    },
    dataType1ChangeForGraph4() {
      if (this.graph4.dataType2 === "구분") {
        this.graph4.heads = [{ name: "No." }, { name: this.graph4.dataType1 === "부서" ? "부서명" : "사업장명" }, { name: "구분" }, { name: "명" }, { name: "전월대비 증감" }];
      } else {
        this.graph4.heads = [{ name: "No." }, { name: this.graph4.dataType1 === "부서" ? "부서명" : "사업장명" }, { name: "구분" }, { name: "직종" }, { name: "명" }, { name: "전월대비 증감" }];
      }
      this.loadGraph4();
    },
    dataType2ChangeForGraph4(dataType) {
      this.graph4.dataType2 = dataType;

      this.dataType1ChangeForGraph4();
    },
  },
};
</script>

<style scoped></style>
